export const buildDatedFilename = (rawFilename: string, extension: string) =>
  `${!!rawFilename ? `${rawFilename}-` : ''}${new Date().toISOString().substring(0, 10)}${!!extension ? `.${extension}` : ''}`;
